<template>
    <div>
       <HeadCommon></HeadCommon>
        <div class="main">
        <div class="head_bg">
            <img src="../img/contact_us-bg.png" alt="">
            <div class="text">
                <p style="color: #fff;">关于我们</p>
                <span></span>
            </div>
        </div>
        <div class="container">
            <div class="brief">
                <img src="../img/brief.png" alt="">
                <div class="text">
                    <p style="font-size: 20px;font-weight: 600;color: #000;">公司简介</p>
                    <span>{{ company_profile }}</span>
                </div>
            </div>
            <div class="advantage">
                <div class="title">
                    <h2>—— 公司具备的优势 ——</h2>
                </div>
                <!-- 公司具备的优势 -->
                <div class="list">
                    <div class="item" v-for="item in advantageList" :key="item.id">
                        <p>{{ item.title }}</p>
                        <span>{{ item.content }}</span>
                    </div>
                </div>
            </div>
            <div class="industry">
                <div class="title">
                    <h2>—— 现参与的虚拟仿真行业 ——</h2>
                </div>
                <!-- 现参与的虚拟仿真行业列表 -->
                <div class="list">
                    <div class="item" v-for="item in joinIndustryList" :key="item.id" >
                        <div class="img">
                            <img :src="item.img" alt="">
                        </div>
                        <div class="text-box">
                            <span>—— {{ item.name }} ——</span>
                        </div>
                        <p style="color: #fff;">{{ item.name }}</p>
                    </div>
                </div>
            </div>
        </div> 
        </div>
        <FootCommon></FootCommon>
    </div>
  </template>
  
  <script>
  import HeadCommon from '@/components/HeadCommon.vue';
  import FootCommon from '@/components/FootCommon.vue';
  import { addressList } from "@/api/about";
  export default {
    name: 'AboutMy',
    components:{
      HeadCommon,
      FootCommon
    },
    data() {
        return{
            company_profile:'',
            // 参与虚拟仿真行业
            joinIndustryList:[],
            //优势
            advantageList:[],
        }
    },
    created() {
        this.addressList()
    },
    methods:{
        async addressList() {
            const {data} = await addressList()
            // console.log(data);
            this.joinIndustryList = data.joinIndustryList
            this.advantageList = data.advantageList
            this.company_profile = data.company_profile
        }
    }
  }
  </script>
  
  <style>
      @import '../style/about_my.css'
  </style>